<template>
  <div id="Creds">
    <h2>Schilderwerken Munsterman</h2>
    <p>Roermondsestraat 16</p>
    <p>6049 AZ Herten - Roermond</p>
    <p>Limburg</p>
    <p>6049 AZ</p>
    <p>Nederland</p>
    <p>Tel: 0475-317386</p>
    <p>Fax: 0475-330343</p>
    <div class="wrapper">
      <iframe src="https://maps.google.com/maps?width=700&amp;height=440&amp;hl=en&amp;q=Roermondsestraat%2016%20Herten+(Titel)&amp;ie=UTF8&amp;t=&amp;z=10&amp;iwloc=B&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ContactCreds'
}
</script>
<style lang="scss" scoped>
  #creds {
    height: 500px;
   //margin-bottom: 10px;
    //padding-bottom: 10px;
    padding-left: 15px;
    border: 2px solid lightgray;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 18px;
    text-align: left;
    .wrapper {
      width: 98%;
      height: 260px;
      margin-top: 2%;
      //margin-bottom: 1%;
      iframe {
        width: 100%;
        height: 100%;
        border: 1px solid black;
      }
    }
  }

  @media screen and (max-width: 750px) {
    #creds {
      padding-left: 10px;
    }
  }

</style>
